<template>
  <div class="specialists-initials">
    <div v-for="specialist in specialists" :key="specialist.fullName" v-bind:class="{'specialist': true}">
      <div class="text-xs-left">
        <v-tooltip bottom>
          <v-chip small label slot="activator">{{ specialist.initials }}</v-chip>
          <span>{{ specialist.fullName }}</span>
        </v-tooltip>
      </div>
    </div>
    <div class="clear-both"></div>
  </div>
</template>

<script>
import _ from 'lodash'

let parenthesesContentRegexp = /\([^)]*\)/g

export default {
  name: 'specialist-initials',
  filters: {},
  props: {
    specialistsRaw: {
      type: String
    },
    specialistsArray: {
      type: Array
    }
  },
  computed: {
    specialists () {
      let splittedWords = this.specialistsArray || _.split(this.specialistsRaw, ',')
      let specialists = []
      for (let splittedWord of splittedWords) {
        let words = _.words(_.trim(_.replace(splittedWord, parenthesesContentRegexp, '')))

        let initials = ''
        for (let word of words) {
          initials += _.toUpper(word[0])
        }

        specialists.push({
          initials: initials,
          fullName: splittedWord
        })
      }

      return specialists
    }
  }
}
</script>

<style scoped>
  .specialists-initials .chip--small {
    height: 22px;
  }

  .specialists-initials .chip--content {
    padding: 0 6px;
  }

  .specialists-initials ul {
    list-style-type: none;
  }

  .specialists-initials .specialist {
    float:left;
  }

  .specialists-initials .clear-both {
    clear:both;
  }
</style>
